/* eslint-disable max-len */
<template>
  <div class="ui-container">
    <header class="ui-header">
      <EbHeader :isManagePage="true" />
    </header>

    <div class="ui-content ui-custom-scrollbar">
      <div class="ui-content-inner">
        <aside class="ui-sidebar">
          <Navbar />
        </aside>

        <main class="ui-main">
          <chrome-warning />

          <transition name="slide-fade">
            <div
              v-if="$route.meta.header"
              class="head-back"
              @click="$router.go(-1)"
            >
              <i class="head-back__icon el-icon-arrow-left" />
              <span class="back">{{ $route.meta.header }}</span>
            </div>
          </transition>

          <!-- 全局公告通知的容器 -->
          <announcement />

          <transition name="slide-fade">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive" />
            </keep-alive>
            <!-- <router-view v-if="!$route.meta.keepAlive"/> -->
          </transition>

          <transition name="slide-fade">
            <router-view v-if="!$route.meta.keepAlive" />
          </transition>
        </main>
      </div>
    </div>

    <qc-dialog
      type="prompt"
      :icon="icon"
      :show.sync="show"
      :text-title="textTitle"
      :text="text"
      :default-cancel="false"
    >
      <qc-button slot="button" size="middle" @click="show = false">
        确定
      </qc-button>
    </qc-dialog>

    <Portals />
  </div>
</template>

<script>
import Navbar from '@/components/navbar';
import Portals from '@/pages/portals';
import announcement from '@/pages/announcement';
import ChromeWarning from '@/components/ChromeWarning';

export default {
  name: 'Index',
  components: {
    Navbar,
    Portals,
    announcement,
    ChromeWarning,
  },
  data() {
    return {
      d: 'M11.3125,3.4109375 L11.3125,2.203125 C11.3125,2.0984375 11.1921875,2.040625 11.1109375,2.1046875 L4.0671875,7.60625 C3.8109375,7.80625 3.8109375,8.1921875 4.0671875,8.3921875 L11.1109375,13.89375 C11.19375,13.9578125 11.3125,13.9 11.3125,13.7953125 L11.3125,12.5875 C11.3125,12.5109375 11.2765625,12.4375 11.2171875,12.390625 L5.5921875,8 L11.2171875,3.6078125 C11.2765625,3.5609375 11.3125,3.4875 11.3125,3.4109375 Z',
      textTitle: '拼多多绑定',
      text: '',
      show: false,
      icon: 'success',
    };
  },
};
</script>

<style lang="less">
@pageBgColor: var(--ui-page-bg-color);
@sidebarW: 210px;
@headerH: 64px;
@contentMinWidth: var(--ui-page-min-width); /* 内容最小宽度 */
@contentMaxWidth: var(--ui-page-max-width); /* 内容最大宽度 */
@layoutSpacing: var(--ui-layout-spacing); /* 布局容器间距 */

.ui-container {
  background-color: @pageBgColor;
}

.ui-header {
  height: @headerH;
  width: 100%;
}

.ui-content {
  box-sizing: border-box;
  height: calc(100vh - @headerH);
  box-sizing: border-box;
  padding: @layoutSpacing 0;
  overflow-y: scroll;
}

.ui-content-inner {
  box-sizing: border-box;
  width: @contentMaxWidth;
  margin: 0 auto;
  display: flex;
}

.ui-sidebar {
  flex: 0 0 auto;
  position: sticky;
  top: 0;
  width: @sidebarW;
  height: calc(100vh - @headerH - @layoutSpacing * 2);
  box-sizing: border-box;
}

.ui-main {
  flex: auto;
  box-sizing: border-box;
  margin: 0 @layoutSpacing;
  width: calc(@contentMaxWidth - @sidebarW - @layoutSpacing * 2);

  .head-back {
    display: flex;
    align-items: center;
    padding: 20px;
    background-color: #fff;
    cursor: pointer;
    .head-back__icon {
      font-size: 16px;
    }
    .back {
      font-size: 16px;
      margin-left: 10px;
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.3s 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(50px);
}
.slide-fade-enter-to,
.slide-fade-leave {
  transform: translateX(0);
}
</style>

<style lang="less">
// 全局通用样式控制
@import "../../pages/common.less";
</style>
